$('.homefeatureedcollection  .product-grid').slick({
  dots: false,
  arrows:true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});



// recently-viewed js
document.addEventListener("DOMContentLoaded", function () {

  let handles = JSON.parse(localStorage.getItem("recently_viewed")) || [];
  let container = document.querySelector(".recently-slider");

  if (!handles.length || !container) return;

  let currentHandle = "{{ product.handle }}";

  // Fetch product cards — keep handle paired with each response
  let requests = handles.map(handle => {
    if (handle === currentHandle) {
      return Promise.resolve({ handle, html: null });
    }

    return fetch(`/products/${handle}?view=card`)
      .then(res => res.text())
      .then(html => ({ handle, html }))
      .catch(() => ({ handle, html: null }));
  });

  Promise.all(requests).then(results => {

    results.forEach(({ handle, html }) => {
      if (!html) return;

      let temp = document.createElement("div");
      temp.classList.add("recentlyviewedslider");
      temp.innerHTML = html;

      let productCard = temp.querySelector(".card-wrapper");
      if (!productCard) return;

      // Store the product URL on the whole card. We navigate from this in the
      // click handler below, so it does NOT matter whether the card markup has
      // an <a> around the image or not.
      productCard.dataset.recentlyUrl = `/products/${handle}`;
      productCard.style.cursor = "pointer";

      temp.innerHTML = "";
      temp.appendChild(productCard);
      container.appendChild(temp);
    });

    // slider init after cards are added
    initSlider();

    // Card-level navigation. Slick blocks/intercepts clicks on inner <a> tags
    // during its drag handling, so instead we capture the click ourselves
    // (capture phase, before Slick) and navigate based on the card's stored URL.
    let recentlyDown = { x: 0, y: 0 };

    // pointerdown covers mouse, touch AND pen -> works on mobile taps too
    container.parentElement.addEventListener("pointerdown", function (e) {
      recentlyDown = { x: e.clientX, y: e.clientY };
    }, true);

    container.parentElement.addEventListener("click", function (e) {

      // Let the add-to-cart / quick-add controls work normally
      if (e.target.closest("product-form, .quick-add, .quick-add-bulk, button, modal-opener, modal-dialog")) {
        return;
      }

      let card = e.target.closest(".card-wrapper");
      if (!card || !card.dataset.recentlyUrl) return;

      let dx = Math.abs(e.clientX - recentlyDown.x);
      let dy = Math.abs(e.clientY - recentlyDown.y);

      // only navigate if pointer barely moved (a click/tap, not a drag/swipe)
      if (dx < 5 && dy < 5) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = card.dataset.recentlyUrl;
      }
    }, true);

  });

  function initSlider() {
    if (typeof $ === "undefined") return;

    let $slider = $('.recently-slider');

    // prevent double init
    if ($slider.hasClass('slick-initialized')) return;

    $slider.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      speed: 300,

      // custom arrows (title ke andar wale)
      arrows: true,
      prevArrow: $('.recent-prev'),
      nextArrow: $('.recent-next'),

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  }

});
// recently-viewed js end


// related-products js
// Dawn's <product-recommendations> loads its cards asynchronously AFTER page
// load, and Slick clones slides — so binding a click listener to each card at
// DOMContentLoaded misses everything. We delegate on the section wrapper (which
// exists from the start) instead, so clicks on cards added later / Slick clones
// all work.
(function () {

  function bindRelated() {
    var scope = document.querySelector(
      "product-recommendations, .product-recommendations, .related-products"
    );
    // fall back to document so it still works if the wrapper class differs
    var root = scope || document;

    if (root.__relatedBound) return;
    root.__relatedBound = true;

    var downPos = { x: 0, y: 0 };

    root.addEventListener("pointerdown", function (e) {
      downPos = { x: e.clientX, y: e.clientY };
    }, true);

    root.addEventListener("click", function (e) {

      // Let buttons / quick-add / right-side controls work normally
      if (e.target.closest("button, .quick-add, .quick-add-bulk, .rightsideofcard, product-form, modal-opener, modal-dialog")) {
        return;
      }

      var card = e.target.closest(".product-card-wrapper, .card-wrapper");
      if (!card) return;

      // Only handle cards that live inside the related / recommendations section
      // (prevents any clash with the recently-viewed handler)
      if (!card.closest("product-recommendations, .product-recommendations, .related-products")) {
        return;
      }

      var link = card.querySelector('a[href*="/products/"]');
      if (!link || !link.href) return;

      var dx = Math.abs(e.clientX - downPos.x);
      var dy = Math.abs(e.clientY - downPos.y);

      // only navigate on a real click/tap, not a drag/swipe
      if (dx < 5 && dy < 5) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = link.href;
      }
    }, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindRelated);
  } else {
    bindRelated();
  }

})();
// related-products js end


// collections page js
// null check added -- this element only exists on collection pages
let filterBtn = document.querySelector('.template_collection .allfilters-button');
if (filterBtn) {
  filterBtn.addEventListener('click', function () {

    const filter = document.querySelector('.template_collection aside#main-collection-filters');
    const grid = document.querySelector('.template_collection .collection .grid');

    if (!filter || !grid) return;

    if (filter.style.display === 'none') {

      // Show filter (wapas normal)
      filter.style.display = 'block';
      grid.classList.remove('grid--4-col-desktop');
      grid.classList.add('grid--3-col-desktop');

    } else {

      // Hide filter
      filter.style.display = 'none';
      grid.classList.remove('grid--3-col-desktop');
      grid.classList.add('grid--4-col-desktop');

    }
  });
}


document.addEventListener("DOMContentLoaded", function () {

  const selectBox = document.getElementById("SortBy");
  const label = document.querySelector(".template_collection .facet-filters__label");

  if (!selectBox || !label) return;

  // Click anywhere on label -> open select
  label.addEventListener("click", function () {
    selectBox.focus();
    selectBox.click(); // trigger dropdown
  });

});

// collections page js end
